// Mensaje para el usuario cuando guardar una promo de venta falla.
import { ApiError } from '@/api/errors';
import type { RetailPromotionsErrorCode } from '../api/promotionsContract';
import { SALE_PROMOTION_FIELD_LABELS, serverFieldMessage } from './serverFieldErrors';

const INVALID_SALE_PROMOTION: RetailPromotionsErrorCode = 'INVALID_SALE_PROMOTION';
const SYSTEM_PROMOTION_FIELD_LOCKED: RetailPromotionsErrorCode = 'SYSTEM_PROMOTION_FIELD_LOCKED';

export const SAVE_ERROR_TITLE = 'No se pudo guardar la promo';
export const INVALID_PROMOTION_FALLBACK =
    'Hay un dato de la promo que no es válido. Revisa las palancas, las fechas y los montos y guarda de nuevo.';
export const FIELD_LOCKED_MESSAGE =
    'Del bono de bienvenida solo se cambia el monto. Recarga la página y guarda de nuevo.';
export const INVALID_WELCOME_BONUS_AMOUNT =
    'El monto del bono tiene que ser mayor a $0. Corrígelo y guarda de nuevo.';

export function saveErrorMessage(error: unknown): string {
    if (error instanceof ApiError && error.code === INVALID_SALE_PROMOTION)
        return serverFieldMessage(error, SALE_PROMOTION_FIELD_LABELS) ?? INVALID_PROMOTION_FALLBACK;
    if (error instanceof ApiError && error.code === SYSTEM_PROMOTION_FIELD_LOCKED)
        return FIELD_LOCKED_MESSAGE;
    if (error instanceof Error && error.message) return error.message;
    return 'No pudimos guardar la promo. Intenta de nuevo en un momento.';
}

/** Del bono solo se manda el monto, así que una promo inválida es un monto inválido. */
export function welcomeBonusSaveErrorMessage(error: unknown): string {
    if (error instanceof ApiError && error.code === INVALID_SALE_PROMOTION)
        return INVALID_WELCOME_BONUS_AMOUNT;
    return saveErrorMessage(error);
}
